export default __webpack_public_path__ + "static/media/Andriod_Icon.88217ebd.svg";